import React, { useContext, useEffect, useState } from "react";
import { ChartDataContext } from "../../hooks/useChartDataQuery";
import styles from "./index.module.scss";
import useFilterChartDataTopics from "../../hooks/useFilterChartDataTopics";
import TopicsSidebar from "../TopicsSidebar";
import TopicChartData from "../TopicChartData";

const ResultNotFound = ({ isAllTheme, keyword }) =>
	isAllTheme ? (
		<h2 className={styles.resultNotFound}>
			oops！找不到含有 <strong>{keyword}</strong> 關鍵字的圖表。
			請嘗試更換關鍵字。
		</h2>
	) : (
		<h2 className={styles.resultNotFound}>
			oops！你指定的類別找不到含有 <strong>{keyword}</strong> 關鍵字的圖表。
			請嘗試更換關鍵字，或點選其他類別。
		</h2>
	);

const ChartDataThemeDetail = () => {
	const { query, setSearch } = useContext(ChartDataContext);
	const { search, filter } = query;
	const { filteredTopics, filteredThemes } = useFilterChartDataTopics(
		search,
		filter,
	);

	const [currentTopic, setCurrentTopic] = useState(
		filteredTopics.length > 0 ? filteredTopics[0] : null,
	);

	const currentTheme = currentTopic
		? filteredThemes.find((theme) => theme.title === currentTopic.theme)
		: null;

	const handleTopicClick = (topic) => {
		setCurrentTopic(filteredTopics.find((t) => t.title === topic));
	};

	useEffect(() => {
		if (!currentTopic && filteredTopics.length > 0) {
			setCurrentTopic(filteredTopics[0]);
		} else if (
			currentTopic &&
			!filteredTopics.find((topic) => topic.title === currentTopic.title)
		) {
			setCurrentTopic(filteredTopics.length > 0 ? filteredTopics[0] : null);
		}
	}, [filteredTopics, currentTopic]);

	const renderClearButton = () => (
		<button
			type="reset"
			className={styles.clearButton}
			onClick={() => {
				setSearch("");
			}}
		>
			清除搜尋結果
		</button>
	);

	if (!currentTheme || !currentTopic) {
		return (
			<section
				className={styles.sectionContainer}
				id="chart-data-detail-section"
			>
				<div className={styles.themeDetail}>
					<ResultNotFound
						isAllTheme={filteredThemes.length === 4}
						keyword={search}
					/>
					{renderClearButton()}
				</div>
			</section>
		);
	}

	return (
		<section className={styles.sectionContainer} id="chart-data-detail-section">
			<div className={styles.themeDetail}>
				{search !== "" && (
					<>
						<p className={styles.searchResult}>
							以下為與 <strong>{search}</strong> 關鍵字相關的搜尋結果
						</p>
						{renderClearButton()}
					</>
				)}
				<h2 className={styles.themeTitle}>{currentTheme.title}</h2>
				<p className={styles.themeDescription}>{currentTheme.description}</p>
			</div>
			<div className={styles.sidebarAndTopic}>
				<TopicsSidebar
					topics={filteredTopics}
					currentTopicTitle={currentTopic.title}
					onTopicClick={handleTopicClick}
				/>
				<TopicChartData topic={currentTopic} />
			</div>
		</section>
	);
};

export default ChartDataThemeDetail;
